import React from 'react'
import { Container } from 'react-bootstrap'
// import { merchBuilder, catalogContainer } from 'src/models'
import { catalogContainer } from 'src/models/Catalog'
import { productDeps, catalogDeps } from 'src/deps'
import {
  BreadCrumb,
  EmptyProduct,
  QuickView,
  ProductCompareFloatingBar,
} from 'src/views/components'
import {
  isMerchPLP,
  enableQuickView,
  enableProductCompare,
} from 'config/appConfig'
// import { catalogState } from 'src/models/Catalog/catalogState'
import MetaDecorator from '../MetaDecorator'
import {
  trackSearchResult,
  trackSearchResultEvent,
  getLiveEventStatus,
  i18nTranslate,
  enableNewFeature,
} from 'src/utils'
import { pageNames } from 'src/routes/pathParams'

const CATALOG_NOT_FOUND_CODE = 'SFOCAT002'
const CATALOG_NOT_FOUND_MESSAGE = /category not found|resource not exist/i

function isCatalogNotFoundFailure(catalogData) {
  if (catalogData?.status !== 'failure') return false
  if (Number(catalogData.statusCode) === 404) return true
  const code = catalogData.code || catalogData.originalCode
  if (code === CATALOG_NOT_FOUND_CODE) return true
  return CATALOG_NOT_FOUND_MESSAGE.test(catalogData.message || '')
}

class CatalogComponent extends React.Component {
  enableLiveEvent = getLiveEventStatus()
  constructor(props, context) {
    super(props, context)
    this.contextName = 'plpData'
    this.context = context

    !isMerchPLP && this.getDataFromSource()

    const categoryId = props?.match?.params?.categoryId || {}

    const compareList = catalogContainer.productCompareList
    if (
      enableProductCompare &&
      compareList.length > 0 &&
      categoryId !== compareList[0].categoryId
    ) {
      catalogContainer.productCompareList = []
    }
  }

  getDataFromSource = () => {
    const catalogData = catalogDeps.getResponseFromContext({
      context: this.context,
      contextName: this.contextName,
      props: this.props,
    })

    const pathname = this.props?.location?.pathname || ''
    const queryParamsFromCurrentUrl = this.props.location?.search || ''
    // to compare url, filter and sort params
    const contextUrlPathFromSSR = catalogData?.contextUrlPathFromSSR || ''
    const contextQueryParamsFromSSR =
      catalogData?.contextQueryParamsFromSSR || ''
    const isSSRDataForCurrentPage =
      contextUrlPathFromSSR === pathname &&
      contextQueryParamsFromSSR === queryParamsFromCurrentUrl
    // console.log(
    //   'isSSRDataForCurrentPage ' +
    //     isSSRDataForCurrentPage +
    //     ' contextUrlPathFromSSR ' +
    //     contextUrlPathFromSSR +
    //     ' pathname ' +
    //     pathname +
    //     ' contextQueryParamsFromSSR ' +
    //     contextQueryParamsFromSSR +
    //     ' queryParamsFromCurrentUrl ' +
    //     queryParamsFromCurrentUrl
    // )
    const hasCatalogResult =
      catalogData?.category?.identifier ||
      catalogData?.searchTerm ||
      (enableNewFeature('enableCategoryProductNotFound') &&
        isCatalogNotFoundFailure(catalogData))
    if (isSSRDataForCurrentPage && hasCatalogResult) {
      this.catalogResponse = catalogData
      if (pathname.includes(pageNames.search)) {
        // this term is used for displaying term with count in search page
        // while clicking back button, the latest search term is not set correctly
        // so adding below fix
        const matchParams = this.props.match?.params || {}
        const searchTerm =
          matchParams?.searchTerm || catalogData?.searchTerm || ''
        catalogDeps.setQueryParamsData(searchTerm)
      }
    } else {
      this.getCatalogResponse()
    }
  }

  getSort = sortValue => {
    this.catalogResponse = catalogDeps.handleSort(sortValue, { ...this.props })
  }

  getPagination = value => {
    this.catalogResponse = catalogDeps.handlePagination(value, {
      ...this.props,
    })
  }

  getCatalogResponse = async () => {
    const searchParams = new URLSearchParams(this.props?.location?.search || '')

    if (searchParams.toString() != '') {
      let searchObject = {}
      searchParams?.forEach((searchValue, searchKey) => {
        searchObject[searchKey] = searchValue
      })
      catalogDeps.queryParam = searchObject
    } else {
      catalogDeps.queryParam = {}
    }
    this.catalogResponse = await catalogDeps.getCatalog({
      ...this.props,
      context: this.context,
      contextName: this.contextName,
    })
    this.enableLiveEvent === 'true' && this.trackSearchEvent()
    this.trackSearch()
  }

  getSearchSuggestions = async () => {
    const response = await catalogContainer.getSearchSuggestions(
      this.catalogResponse?.searchTerm,
      1,
      6
    )
    return response?.product || []
  }

  getSuggestionListNames = suggestionList => {
    return (
      suggestionList.map?.(product => product?.properties?.name || '') || []
    )
  }
  trackSearchEvent = async () => {
    const searchParams = this.props?.match?.params?.searchTerm || ''
    const suggestionList = await this.getSearchSuggestions()
    const suggestionListNames = this.getSuggestionListNames(suggestionList)
    if (searchParams) {
      trackSearchResultEvent({
        searchType: 'product_search',
        searchTerm: searchParams,
        products: this.catalogResponse?.product,
        isPlainSearch: catalogDeps?.isPlainSearch,
        suggestionList: suggestionListNames,
      })
      // Popular search is currently not available in the UI
      // trackSearchResultEvent({
      //   searchType: 'popular_search',
      //   searchTerm: searchParams,
      //   products: this.catalogResponse?.product,
      //   isPlainSearch: catalogDeps?.isPlainSearch,
      //   suggestionList: suggestionListNames,
      // })
    }
  }

  trackSearch = () => {
    const searchParams = this.props?.match?.params?.searchTerm || ''

    if (searchParams) {
      trackSearchResult({
        searchType: 'productSearch',
        searchTerm: searchParams,
        products: this.catalogResponse?.product,
        isPlainSearch: catalogDeps?.isPlainSearch,
      })
    }
  }

  // handleMerchData = parsedData => {
  //   this.catalogResponse = merchBuilder.transformResponse(parsedData)
  // }

  // componentDidMount() {
  //   /**
  //    * @note
  //    * not found loadMerchData() function anywhere so commenting out
  //    */
  //   catalogState.loadMerchData({ handleMerchData: this.handleMerchData })
  // }

  componentDidUpdate(prevProps) {
    !isMerchPLP && this.checkAndUpdateComponent(prevProps)
  }

  checkAndUpdateComponent = async prevProps => {
    if (
      JSON.stringify(prevProps.location) !== JSON.stringify(this.props.location)
    ) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        catalogContainer.productCompareList = []
      }
      await this.getCatalogResponse()
      if (typeof window === 'object') {
        window.scrollTo(0, 0)
      }
    }
  }

  render() {
    const { category = [], status = '' } = this.catalogResponse || {}
    const breadCrumbList = productDeps.getBreadCrumbList(category)
    const categoryName =
      this.catalogResponse?.category?.properties?.name ||
      catalogDeps?.queryParam?.searchTerm ||
      ''
    const title = i18nTranslate('productListPage.title', 'Nu Skin |', {
      nameSpace: 'ssr-resource',
    })
    const productListTitle = `${title} ${categoryName}`
    const products = this.catalogResponse?.product || []

    return (
      <>
        <MetaDecorator
          title={productListTitle}
          imageUrl=""
          imageAlt=""
          description={categoryName}
          location={this.props}
        />
        <BreadCrumb
          breadCrumbList={breadCrumbList}
          location={this.props.location}
        />
        <section className={`main-catalog-page bg-light ${this.template}`}>
          {enableProductCompare && <ProductCompareFloatingBar />}
          {enableQuickView && !isMerchPLP && <QuickView />}

          <Container className="p-0 mt-2">
            {status === 'failure' || (status != '' && products.length == 0) ? (
              <EmptyProduct {...this.props} />
            ) : (
              <> </>
            )}
          </Container>
        </section>
      </>
    )
  }
}

export { CatalogComponent }
export default CatalogComponent
